<template>
  <div class="examAchievement">
    <div class="content">
      <div class="examAchievement-left">
        <div class="examAchievement-text">{{name}}的考试成绩</div>
        <div class="trend">
          <div class="trend-left">
            <div class="examAchievement-mark">
              <span class="examAchievement-mark-number">{{examAchievementdate.examScore}}</span>分
            </div>
            <div class="examAchievement-information">
              <div
                class="examAchievement-information-one"
              >用时：{{examAchievementdate.exerciseTime}}min</div>
              <div class="examAchievement-information-two">正确：{{examAchievementdate.correctNum}}</div>
              <div class="examAchievement-information-two">错误：{{examAchievementdate.wrongNum}}</div>
              <div class="examAchievement-information-two">未做：{{examAchievementdate.emptyNum}}</div>
            </div>
          </div>
        </div>

        <div class="examAchievement-examAchievement-type">
          <div
            class="examAchievement-button"
            @click="goExamMode(examAchievementdate.exerciseId,false)"
          >查看全部解析</div>
          <div
            class="examAchievement-button"
            @click="goExamMode(examAchievementdate.exerciseId,true)"
          >查看本次错题</div>
        </div>
      </div>
      <div class="examAchievement-right">
        <div class="examAchievement-text">答题卡</div>
        <div
          class="right-content-mian"
          v-for="(item,index) in examAchievementdate.cardList"
          :key="index"
        >
          <div class="mian-title">
            {{item.typeName}}
            <span>&nbsp;&nbsp;&nbsp;&nbsp;(每题{{item.questionTypeScore}}分，共{{item.questionTypeCount}}题)</span>
          </div>

          <div class="select">
            <div v-for="(items,indexs) in item.numberList" :key="indexs">
              <div
                style="font-size:13px"
                :class="isInArray(items,examAchievementdate.correctNumberList)?'select-item ge':isInArray(items,examAchievementdate.wrongNumberList)?'select-item re':'select-item'"
              >{{items}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      index: 1,
      examAchievementdate: {},
      name: null
    };
  },
  mounted() {
    this.name = this.$route.query.name
    this.getData();
  },
  methods: {
    getData() {
      let obj = {
        studentId: this.$route.query.studentId,
        studentExerciseId: this.$route.query.studentExerciseId
      }
      this.api.examStudent
        .getExerciseResultById(obj)
        .then(result => {
          if(result.success){
            this.examAchievementdate = result.data;
            localStorage.setItem("examAchievement",JSON.stringify(this.examAchievementdate))
          }else{
            this.$message.error(result.message)
          }
        })
      // this.examAchievementdate = JSON.parse(localStorage.getItem("examAchievement"));
    },
    goExamMode(exerciseId, sty) {
      let obj = {
        exerciseId: exerciseId,
        sty: sty
      };
      localStorage.setItem("jump",JSON.stringify(obj))
      this.$router.push({path:"/examination"})
    }
  },
  watch: {}
};
</script>
<style scoped>
.examAchievement {
  width: 100%;
  margin: auto;
  background: #fff;
  min-height: calc(100%);
}
.examAchievement-left {
  width: 45%;
}
.examAchievement-right {
  width: 50%;
  margin-left: 5%;
}
.header-title {
  font-size: 14px;
  padding: 20px;
  background-color: #fff;
  border-bottom: 1px solid rgb(246, 246, 246);
}
.content {
  padding: 20px;
  display: flex;
}
.trend {
  display: flex;
}
.trend-left {
  display: flex;
}
.examAchievement-mark {
  width: 180px;
  height: 180px;
  background-color: rgba(65, 212, 151, 1);
  border-radius: 50%;
  line-height: 180px;
  text-align: center;
  margin-top: 50px;
  margin-left: 30px;
  color: #fff;
}
.examAchievement-mark-number {
  font-size: 48px;
}
.examAchievement-information {
  margin-top: 70px;
  margin-left: 70px;
  font-size: 13px;
}
.examAchievement-information-two {
  margin-top: 20px;
}
.examAchievement-information-number {
  color: rgba(199, 0, 10, 1);
  font-size: 16px;
  margin-left: 50px;
}
.title {
  font-size: 24px;
  text-align: center;
}

.dashboard-show-data {
  width: 50%;
  height: 470px;
  background: #fff;
  margin-top: 20px;
  padding: 10px 10px 0px 0px;
}
.examAchievement-examAchievement-type {
  display: flex;
  margin: 20px auto;
  width: 500px;
}
.examAchievement-button {
  width: 180px;
  height: 48px;
  background-color: rgba(77, 148, 255, 1);
  line-height: 48px;
  text-align: center;
  border-radius: 33px;
  margin: 10px;
  margin-top: 50px;
  color: #ffffff;
  font-size: 13px;
}
.examAchievement-button:hover {
  cursor: pointer;
  background-color: rgba(77, 148, 255, 0.7);
}
.examAchievement-text{
  font-size: 16px;
}
</style>
<style lang="less" rel="stylesheet/less">
.examAchievement {
  .right-content-mian {
    .select {
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      .select-item {
        cursor: pointer;
        width: 44px;
        height: 30px;
        color: rgb(69, 90, 100);
        line-height: 30px;
        text-align: center;
        border: rgb(162, 170, 188) 1px solid;
        border-radius: 4px;
        margin-right: 10px;
        margin-bottom: 10px;
        a {
          color: rgb(69, 90, 100) !important;
          border-bottom: 0px !important;
          text-decoration: none !important;
        }
      }
      .none {
        background: rgb(162, 170, 188);
        border: rgb(162, 170, 188) 1px solid;

        color: #fff;
        &:hover {
          opacity: 0.6;
        }
      }
      .re {
        background: rgb(252, 94, 94);
        border: rgb(252, 94, 94) 1px solid;

        color: #ffffff;
        a {
          color: #ffffff !important;
          text-decoration: none !important;
          border-bottom: 0px !important;
        }
        &:hover {
          opacity: 0.6;
        }
      }
      .ge {
        background: #41d497;
        border: #41d497 1px solid;

        color: #ffffff;
        &:hover {
          opacity: 0.6;
        }
      }
    }
    .mian-title {
      line-height: 40px;
      background-color: rgba(250, 250, 250, 1);
      margin-top: 10px;
      padding-left: 10px;
      font-size: 13px;
      color: rgb(69, 90, 100);
      border-radius: 5 px;
      span {
        color: #a2aabc;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fullTruthModelTest/examAchievement.vue